import type { TFunction } from "i18next"
import { z } from "zod"

export const defaultersFilterFormSchema = (t: TFunction) =>
  z.object({
    queryType: z.string().optional(),
    startDateTime: z.date({
      required_error: t("validation.startDateRequired"),
    }),
    endDateTime: z.date({
      required_error: t("validation.endDateRequired"),
    }),
    name: z.string().optional(),
    document: z.string().optional(),
    ownId: z.string().optional(),
    code: z.string().optional(),
  })
export type DefaultersFilterFormSchemaProps = z.infer<
  ReturnType<typeof defaultersFilterFormSchema>
>
